/**
 * Generates callback function to show popover record
 *
 * @param {object} parms - Parameters
 * @param {function} param.showRecordPopover - A callback to show popover
 * @param {function} param.recordsShowPopover - A callback to show popover
 * @param {function} param.recordsShowRecord - A callback to show record
 *
 * @returns {function} - Callback - A function to be called when item is pressed
 */
import {ReportProps} from '../Report.types';

export function generateOnRecordPress({
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) {
  return ({id}: any) =>
    showRecordPopover([id], {recordsShowPopover, recordsShowRecord});
}
